/** Authored canvas order takes precedence over the View's base/preference order. */
export function orderedVisibleColumns<T extends { field: string }>(
  columns: T[],
  visibleColumns?: string[],
): T[] {
  if (!visibleColumns?.length) return columns;
  const byField = new Map(columns.map((column) => [column.field, column]));
  const seen = new Set<string>();
  const ordered: T[] = [];
  for (const field of visibleColumns) {
    const column = byField.get(field);
    if (column && field !== "_actions" && !seen.has(field)) {
      ordered.push(column);
      seen.add(field);
    }
  }
  return [
    ...ordered,
    ...columns.filter((column) => column.field === "_actions"),
  ];
}
